//引入react核心库
import React from "react";
//引入ReactDOM
import ReactDOM from "react-dom";
//引入APP
import App from './App' //勿删
//引入路由
import {MyRouter} from '@/router'
ReactDOM.render(
    <MyRouter />,
    document.getElementById('root')
)